import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import store from "./store" 
const app = (
    <Provider store={store}>
         <App />
    </Provider>
  )

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
